import { Node, mergeAttributes } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    caption: {
      setCaption: () => ReturnType;
      toggleCaption: () => ReturnType;
    };
  }
}

export const Caption = Node.create({
  name: 'caption',
  group: 'block',
  content: 'inline*',

  parseHTML() {
    return [
      {
        tag: 'div[data-type="caption"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'caption',
        class: 'caption',
      }),
      0,
    ];
  },

  addCommands() {
    return {
      setCaption:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            content: [{ type: 'text', text: 'Caption' }],
          });
        },
      toggleCaption:
        () =>
        ({ commands }) => {
          return commands.toggleWrap(this.name);
        },
    };
  },
});
